// Shared color palette and logic for collection avatars and tab indicators
//export const PALETTE = ['#BDC793', '#F4E0A9', '#A8C2DD', '#D6977E', '#BFA98F', '#DFAF6F', '#EAC96A', '#E06447', '#99BA75'];

export const PALETTE = [
  '#BDC793',
  '#F4E0A9',
  '#A8C2DD',
  '#D6977E',
  '#BFA98F',
  '#DFAF6F',
  '#EAC96A',
  '#E06447',
  '#99BA75',
  '#8BA864',
  '#C3B48A',
  '#F1D17A',
  '#E88A59',
  '#A2B6CF',
  '#D3C2A1',
  '#B9876D',
  '#E5B87C',
  '#9DBE82',
  '#F6E5C1',
  '#FDFCF9',
  '#D8A593',
  '#C9A078',
  '#ECC27B',
  '#C66D54',
];

function hexToLuminance(hex: string) {
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16) / 255;
  const g = parseInt(c.substring(2, 4), 16) / 255;
  const b = parseInt(c.substring(4, 6), 16) / 255;
  const a = [r, g, b].map((v) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)));
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function contrastTextColor(hex: string) {
  const lum = hexToLuminance(hex);
  return lum > 0.179 ? '#000' : '#fff';
}

function sumCharCodes(s: string) {
  let total = 0;
  for (let i = 0; i < s.length; i++) total += s.charCodeAt(i);
  return total;
}

export interface CollectionColorItem {
  id: string | number;
  name: string;
  isDefault?: boolean;
  color?: string; // explicit background color (e.g. '#RRGGBB' or '#AARRGGBB')
}

/**
 * Get avatar colors for a collection
 * @param item Collection item with id, name, and optional isDefault flag
 * @param offset Optional offset for color rotation
 * @returns Object with bg (background) and color (text) properties
 */
export function getCollectionColors(item: CollectionColorItem, offset = 0): { bg: string; color: string } {
  // If an explicit color is provided (from DB), use it directly
  if (item.color) return { bg: item.color, color: '#000' };

  // default collection: dark blue background, white text
  if (item.isDefault) return { bg: '#0d47a1', color: '#000' };

  // AF collections — yellow background, black text
  if (item.name && item.name.toLowerCase().startsWith('af')) return { bg: '#FFEB3B', color: '#000' };

  const base = Math.abs(sumCharCodes(String(item.id))) % PALETTE.length;
  const idx = (base + offset) % PALETTE.length;
  const bg = PALETTE[idx];
  return { bg, color: '#000' };
}
